import { RootState } from '@/Redux/RootReducer';
import { createSelector } from 'reselect';

const translation = (root: RootState) => root.global.translation;

const documentFoldersData = (root: RootState) => root.dynamicData.documentFoldersData;

const documentFolders = createSelector([documentFoldersData, translation], (state, translation) => {
  const categories = translation.Pages.Settings.OnlineArchiveSettings.AllocateCategories.DisabledCategories;

  return state.documentFolders
    .map((f) => ({ ...f, name: categories[f.name as keyof typeof categories] ?? f.name }))
    .sort((a, b) => a.name.localeCompare(b.name));
});

const documentFolderOptions = createSelector([documentFolders], (documentFolders) => {
  return documentFolders.map((item) => ({ key: item.id, value: item.name }));
});

const sortedDocumentFolders = createSelector([documentFolders, translation], (state, translation) => {
  const categories = translation.Pages.Settings.OnlineArchiveSettings.AllocateCategories.DisabledCategories;

  const defaultFolderNames = [categories.Open, categories.Completed, categories.Deleted];

  return [
    ...state.filter((item) => item.name === defaultFolderNames[0]),
    ...state.filter((item) => !defaultFolderNames.includes(item.name)),
    ...state.filter((item) => defaultFolderNames.slice(1).includes(item.name)),
  ];
});

export const documentFoldersDataSelectors = {
  documentFolders,
  documentFolderOptions,
  sortedDocumentFolders,
};
